module.exports = __webpack_public_path__ + "img/medicalspa_01.6633128b.jpg";